import { Key } from "react";
import styled from "@emotion/styled";
import { MDSToggleButtonGroup, MDSToggleButtonGroupItem } from "@/mds";

interface YesNoInputProps {
  value: boolean;
  onChange: (createFromHashtags: boolean) => void;
}

export const YesNoInput = ({ value, onChange }: YesNoInputProps) => {
  const handleSelectionChange = (keys: Set<Key>) => {
    const selectedKey = Array.from(keys)[0] as string;
    onChange(selectedKey === "yes");
  };

  return (
    <StyledWrapper>
      <MDSToggleButtonGroup
        selectionMode="single"
        onSelectionChange={handleSelectionChange}
        selectedKeys={value ? ["yes"] : ["no"]}
      >
        <MDSToggleButtonGroupItem ariaLabel="No" id="no">
          No
        </MDSToggleButtonGroupItem>
        <MDSToggleButtonGroupItem ariaLabel="Yes" id="yes">
          Yes
        </MDSToggleButtonGroupItem>
      </MDSToggleButtonGroup>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  width: 100%;
`;
